import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

type Props = {
  modelInfo?: {
    height?: string;
    size?: string;
  };
};

export default function ProductModelInfo({ modelInfo }: Props) {
  if (!modelInfo) return null;
  const modelHeight = modelInfo.height || '';
  const modelSize = modelInfo.size || '';

  if (!modelHeight && !modelSize) return null;

  return (
    <div className="mb-4 border bg-rgrey-lightborder p-3 rounded-sm">
      <InformationCircleIcon
        className="h-5 w-5 inline-block mr-2 text-rgrey-darker"
        aria-hidden="true"
      />
      <span className="text-rgrey-darker text-xs">
        {modelHeight && modelSize && (
          <span>
            Modelli pikkus on {modelHeight} cm ja kannab suurust{' '}
            <span className="capitalize">{modelSize}</span>.
          </span>
        )}
        {!modelHeight && modelSize && (
          <span>
            Modell kannab suurust{' '}
            <span className="capitalize">{modelSize}</span>.
          </span>
        )}
        {modelHeight && !modelSize && (
          <span>Modelli pikkus on {modelHeight} cm.</span>
        )}
      </span>
    </div>
  );
}
